export type RuntimeConfig = {
    version: string;
    publicPath: string;

    locales: string[];

    initialLanguage: {
        internalCode: string;
        translationCode: string;
    };

    router: {
        id?: string | null;
        hostname: string;
        pathname: string;
        withAdmin: boolean;
        googleTagManager?: {
            id: string;
        };
        pixel?: {
            id: string;
        };
        linkedInInsight?: {
            id: string;
        };
        blueKai?: {
            id: string;
        };
        tikTok?: {
            id: string;
        };
        snapChat?: {
            id: string;
        };

        nonce?: string;
    };

    sentry: {
        dsn?: string;
        release?: string;
        environment?: string;
        tracing: boolean;
        tracesSampleRate: number;
        profiling: boolean;
        replay: boolean;
        replaySampleRate: number;
        profilingSampleRate: number;
    };

    theme?: string;
    favicon?: string;
    languageCaches: { [language: string]: string };

    vat: number;
    instance: 'audi' | 'psme' | 'default';
    enableGenAI: boolean;
};

const runtime = JSON.parse(document.querySelector('script[data-role="runtime-config"]').textContent) as RuntimeConfig;

export default runtime;
